// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-area{
    margin: 50px 0 50px 0;
  }
  .footer-area p{
    font-weight: 600;
  }

  .footer-area {
    position: relative;
    z-index: 1;
  }
  
  .footer-area .h1-footer-dot {
    right: 0;
    bottom: 0;
    z-index: -1;
  }

  .container h1{
    font-family: "Rubrik", sans-serif;
  }

  .trip-section-title h1 {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 68px;
    color: #221314;
  }
  
  .trip-section-title h1 span {
    position: relative;
    z-index: 1;
    display: inline-block;
    line-height: 1;
  }
  
  .trip-section-title h1 span::before {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 18px;
    width: 100%;
    content: "";
    z-index: -1;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .footer-content{
    font-weight: 600;
  }
  .footer-content a{
    color: #0b3763;
  }

  .footer-social-links{
    margin: 10px 0 50px 0;
  }

  .social-icons a i{
    font-size: 25px;
  }

  .footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footer-text span{
    padding-right: 30px;
  }

  @media only screen and (max-width: 767px){
    .footer{
      display: block;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer2.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,WAAW;IACX,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,cAAc;IAChB;EACF","sourcesContent":[".footer-area{\n    margin: 50px 0 50px 0;\n  }\n  .footer-area p{\n    font-weight: 600;\n  }\n\n  .footer-area {\n    position: relative;\n    z-index: 1;\n  }\n  \n  .footer-area .h1-footer-dot {\n    right: 0;\n    bottom: 0;\n    z-index: -1;\n  }\n\n  .container h1{\n    font-family: \"Rubrik\", sans-serif;\n  }\n\n  .trip-section-title h1 {\n    font-family: \"Roboto\", sans-serif;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 48px;\n    line-height: 68px;\n    color: #221314;\n  }\n  \n  .trip-section-title h1 span {\n    position: relative;\n    z-index: 1;\n    display: inline-block;\n    line-height: 1;\n  }\n  \n  .trip-section-title h1 span::before {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    height: 18px;\n    width: 100%;\n    content: \"\";\n    z-index: -1;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n\n  .footer-content{\n    font-weight: 600;\n  }\n  .footer-content a{\n    color: #0b3763;\n  }\n\n  .footer-social-links{\n    margin: 10px 0 50px 0;\n  }\n\n  .social-icons a i{\n    font-size: 25px;\n  }\n\n  .footer{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .footer-text span{\n    padding-right: 30px;\n  }\n\n  @media only screen and (max-width: 767px){\n    .footer{\n      display: block;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
